import { createSlice } from "@reduxjs/toolkit";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";
import { dictService } from "../../services/dictService";

export const getSubjects = createCustomAsyncThunk(
    "dicts/subjects/get",
    async params => await dictService.getSubjects(params)
)

const subjectsSlice = createSlice({
    name: "dicts/subjects",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getSubjects.pending, state => { state.isLoading = true })
            .addCase(getSubjects.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getSubjects.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const subjectSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.subjects)

export default subjectsSlice.reducer